export const API = process.env.REACT_APP_BACKEND_URL;

export const PERIODS = [
  { key: "today", label: "Aujourd'hui" }, { key: "7d", label: "7 jours" },
  { key: "30d", label: "30 jours" }, { key: "month", label: "Mois en cours" },
  { key: "all", label: "Tout" }, { key: "custom", label: "Personnalisée" },
];

export const EMPLOYER_STATUS_LABELS = {
  nouveau_prospect: "Nouveau prospect", a_contacter: "À contacter", premier_contact: "Premier contact effectué",
  en_attente_reponse: "En attente de réponse", interesse: "Intéressé", rendez_vous_planifie: "Rendez-vous planifié",
  discussion_en_cours: "Discussion en cours", informations_demandees: "Informations demandées",
  documents_en_attente: "Documents en attente", offre_transmise: "Offre de services transmise",
  negociation_en_cours: "Négociation en cours", client_confirme: "Client confirmé",
  recrutement_en_cours: "Recrutement en cours", documents_recus: "Documents reçus",
  en_pause: "En pause", non_interesse: "Non intéressé", prospect_perdu: "Prospect perdu",
};

export const CANDIDATE_STATUS_LABELS = {
  nouveau_candidat: "Nouveau candidat", profil_incomplet: "Profil incomplet", cv_recu: "CV reçu",
  documents_a_completer: "Documents à compléter", analyse_en_cours: "Profil en cours d'analyse",
  profil_admissible_offre: "Profil admissible (critères de l'offre)", preselectionne: "Présélectionné",
  propose_employeur: "Proposé à l'employeur", entretien_a_planifier: "Entretien à planifier",
  entretien_planifie: "Entretien planifié", entretien_realise: "Entretien réalisé",
  en_attente_decision: "En attente de décision", retenu: "Retenu", non_retenu: "Non retenu",
  offre_proposee: "Offre d'emploi proposée", offre_acceptee: "Offre acceptée",
  recrutement_termine: "Recrutement terminé", inactif: "Inactif", candidature_retiree: "Candidature retirée",
  entrevue: "Entretien", nouveau: "Nouveau",
};

export const INTERACTION_TYPES = {
  appel: "Appel", courriel: "Courriel", message: "Message", rendez_vous: "Rendez-vous",
  note: "Note interne", relance: "Relance", document: "Document", offre_services: "Offre de services",
  changement_statut: "Changement de statut", resultat: "Résultat",
};

export const statusLabel = (s, kind) =>
  (kind === "candidate" ? CANDIDATE_STATUS_LABELS : EMPLOYER_STATUS_LABELS)[s] || s || "—";

export const fmtDate = (v) => (v ? new Date(v).toLocaleDateString("fr-CA") : "—");

export const STATUS_COLOR = (s) =>
  ["client_confirme", "recrutement_en_cours", "retenu", "offre_acceptee", "recrutement_termine", "interesse", "preselectionne"].includes(s)
    ? "bg-green-50 text-green-700"
    : ["prospect_perdu", "non_interesse", "non_retenu", "candidature_retiree"].includes(s)
      ? "bg-red-50 text-red-600"
      : ["en_pause", "inactif", "en_attente_reponse", "en_attente_decision"].includes(s)
        ? "bg-amber-50 text-amber-700"
        : "bg-blue-50 text-brand-blue";
